import { env } from '@/env';
import { getLogtoRolesFromAccessToken } from '@/lib/logto';

/**
 * «Limulo e' la fonte?» — il predicato che decide DA DOVE una schermata legge l'account di gioco.
 *
 * Era una riga dentro `routes/settings/LinkedAccounts.tsx` (`env.featureLimuloEnabled && isBeta`).
 * Decks e Battles devono rispondere alla STESSA domanda, e una seconda copia della riga diverge:
 * la prima sostituzione per sezione dice «collegato» dal profilo Limulo, la seconda dal profilo
 * qduels, e nessun errore lo segnala. ⇒ Una definizione sola, qui; React la legge da
 * `hooks/useLimuloIsTheSource.ts`, il codice fuori da React (l'header verso QBot) da
 * `limuloIsTheSourceNow`.
 *
 * ⚠️ E' una scelta di BUILD + RUOLO, mai un ripiego: «prova Limulo e ricadi su qduels» sarebbe un
 * guasto d'identita' (due spazi di id), non una resilienza. In produzione il flag e' spento
 * (opt-in, `.env.production` non lo dichiara) e il ramo non si esegue mai.
 */
export function limuloIsTheSource(featureLimuloEnabled: boolean, isBeta: boolean): boolean {
  return featureLimuloEnabled && isBeta;
}

/**
 * La stessa domanda fuori da React, per chi non puo' usare un hook (`prepareHeaders`).
 * Legge il ruolo dal token corrente a ogni chiamata, come `useLogtoRoles` al suo interno.
 *
 * ⚠️ `authed` e' `state.auth.bridgeAuthenticated`, LO STESSO che `useLogtoRoles` guarda: senza
 * sessione i ruoli sono `[]` anche se in `localStorage` resta un token con `beta` (misurato dalla
 * revisione di #506: con `bridgeAuthenticated=false` l'hook diceva `false` e la richiesta
 * partiva CON l'header). Un predicato con due definizioni di «ho il ruolo» e' due predicati.
 */
export function limuloIsTheSourceNow(authed: boolean): boolean {
  const roles = authed ? getLogtoRolesFromAccessToken() : [];
  return limuloIsTheSource(env.featureLimuloEnabled, roles.includes('beta'));
}
